<template>
  <div class="admin-layout">
    <div class="admin-sidebar">
      <div class="admin-sidebar-logo">
<!--        <img src="/logo.png" alt="Logo" />-->
        <span>管理后台</span>
      </div>
      <nav class="admin-nav">
        <a href="javascript:void(0)"
           :class="{ active: tab === 'users' }"
           @click="switchTab('users')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
          人员列表
        </a>
        <a href="javascript:void(0)"
           :class="{ active: tab === 'records' }"
           @click="switchTab('records')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z"/></svg>
          评测记录
        </a>
        <a href="javascript:void(0)"
           :class="{ active: tab === 'config' }"
           @click="switchTab('config')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.49.49 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>
          开发者选项
        </a>
      </nav>
      <div class="admin-sidebar-bottom">
        <div class="admin-user-info">
          <span class="admin-avatar">{{ (adminUser || 'A').charAt(0).toUpperCase() }}</span>
          <span class="admin-username">{{ adminUser }}</span>
        </div>
        <a href="javascript:void(0)" class="admin-logout" @click="logout">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
          退出登录
        </a>
      </div>
    </div>
    <div class="admin-main">
      <!-- ========== Toast 通知 ========== -->
      <transition-group name="toast-slide" tag="div" class="toast-container">
        <div v-for="t in toasts" :key="t.id" :class="['toast', 'toast-' + t.type]">
          <svg v-if="t.type === 'success'" class="toast-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
          <svg v-else-if="t.type === 'error'" class="toast-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
          <svg v-else class="toast-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
          <span class="toast-msg">{{ t.message }}</span>
          <button class="toast-close" @click="removeToast(t.id)">&times;</button>
        </div>
      </transition-group>

      <!-- ========== 确认弹窗 ========== -->
      <transition name="modal-fade">
        <div class="confirm-overlay" v-if="confirmVisible" @click.self="cancelConfirm">
          <div class="confirm-box">
            <div class="confirm-icon" :class="'confirm-icon-' + confirmData.type">
              <svg v-if="confirmData.type === 'danger'" width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
              <svg v-else width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
            </div>
            <h3 class="confirm-title">{{ confirmData.title }}</h3>
            <p class="confirm-msg">{{ confirmData.message }}</p>
            <div class="confirm-actions">
              <button class="btn-cancel" @click="cancelConfirm">取消</button>
              <button :class="['btn-confirm', confirmData.type === 'danger' ? 'btn-confirm-danger' : '']" @click="doConfirm">确定</button>
            </div>
          </div>
        </div>
      </transition>

      <!-- 评测记录模块 -->
      <div v-if="tab === 'records'" class="admin-panel">
        <h2 class="panel-title">评测记录管理</h2>
        <div class="search-bar">
          <div class="search-group">
            <label>账号</label>
            <input v-model="search.username" placeholder="搜索账号" @keyup.enter="loadRecords(1)" />
          </div>
          <div class="search-group">
            <label>邮箱</label>
            <input v-model="search.email" placeholder="搜索邮箱" @keyup.enter="loadRecords(1)" />
          </div>
          <div class="search-group">
            <label>评分范围</label>
            <div class="score-range">
              <input v-model="search.scoreMin" type="number" placeholder="最低" />
              <span>-</span>
              <input v-model="search.scoreMax" type="number" placeholder="最高" />
            </div>
          </div>
          <div class="search-group">
            <label>开始时间</label>
            <input v-model="search.startTime" type="datetime-local" />
          </div>
          <div class="search-group">
            <label>结束时间</label>
            <input v-model="search.endTime" type="datetime-local" />
          </div>
          <div class="search-actions">
            <button class="btn-search" @click="loadRecords(1)">查询</button>
            <button class="btn-reset" @click="resetSearch">重置</button>
          </div>
        </div>
        <div class="table-info">
          <span>共 <strong>{{ recordData.total || 0 }}</strong> 条记录</span>
        </div>
        <table class="admin-table" v-if="recordData.records && recordData.records.length">
          <thead>
            <tr>
              <th>ID</th>
              <th>账号</th>
              <th>邮箱</th>
              <th>测试编号</th>
              <th>评分</th>
              <th>时长(分钟)</th>
              <th>状态</th>
              <th>测试时间</th>
              <th style="width:80px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in recordData.records" :key="r.id">
              <td>{{ r.id }}</td>
              <td>{{ r.username }}</td>
              <td>{{ r.email }}</td>
              <td>{{ r.testId }}</td>
              <td><span class="score-badge">{{ r.score != null ? r.score : '--' }}</span></td>
              <td>{{ r.duration || '--' }}</td>
              <td>
                <span :class="['status-tag', r.status === 1 ? 'status-ok' : r.status === 2 ? 'status-cancel' : 'status-ing']">
                  {{ r.status === 1 ? '已完成' : r.status === 2 ? '提前中止' : '进行中' }}
                </span>
              </td>
              <td>{{ formatDate(r.testDate) }}</td>
              <td><button class="btn-link" @click="showDetail(r.testId)">详情</button></td>
            </tr>
          </tbody>
        </table>
        <p class="empty" v-else>暂无记录</p>

        <!-- 题目详情弹窗 -->
        <div class="modal-overlay" v-if="detailVisible" @click.self="detailVisible = false">
          <div class="modal detail-modal">
            <h3>题目详情 — {{ detailSessionId }}</h3>
            <div v-if="detailLoading" class="detail-loading">加载中...</div>
            <div v-else-if="detailRounds.length === 0" class="empty">暂无题目数据</div>
            <div v-else>
              <div class="detail-phase" v-for="ph in detailPhases" :key="ph.phase">
                <h4 class="detail-phase-title">{{ ph.label }}（{{ ph.rounds.length }} 题）</h4>
                <table class="detail-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>题型</th>
                      <th>题目</th>
                      <th>学生回答</th>
                      <th>发音</th>
                      <th>流利度</th>
                      <th>完整度</th>
                      <th>LLM</th>
                      <th>得分</th>
                      <th>状态</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in ph.rounds" :key="r.roundNumber"
                        :class="{ 'row-failed': r.scoringStatus === 'failed' }">
                      <td>{{ r.roundNumber }}</td>
                      <td><span class="type-tag-sm">{{ questionTypeLabel(r.questionType) }}</span></td>
                      <td class="td-detail-q">
                        <div class="dq-scenario" v-if="r.scenarioText && r.scenarioText !== '（阶段超时，未作答）'">{{ r.scenarioText }}</div>
                        <div class="dq-question">{{ r.questionText }}</div>
                      </td>
                      <td class="td-detail-a">
                        <div v-if="r.userTextAnswer">{{ r.userTextAnswer }}</div>
                        <span v-else-if="r.scenarioText === '（阶段超时，未作答）'" class="timeout-text">超时未答</span>
                        <span v-else-if="r.answerType === 'audio'" class="audio-text">语音回答</span>
                        <span v-else class="no-answer">未作答</span>
                      </td>
                      <td>{{ r.pronAccuracy != null ? Math.round(r.pronAccuracy) : '-' }}</td>
                      <td>{{ r.pronFluency != null ? Math.round(r.pronFluency) : '-' }}</td>
                      <td>{{ r.pronCompletion != null ? Math.round(r.pronCompletion) : '-' }}</td>
                      <td>{{ r.llmScore != null ? Math.round(r.llmScore) : '-' }}</td>
                      <td class="td-detail-score">{{ r.suggestedScore != null ? Math.round(r.suggestedScore) : (r.llmScore != null ? Math.round(r.llmScore) : '-') }}</td>
                      <td>
                        <span :class="['status-tag', r.scoringStatus === 'scored' ? 'status-ok' : r.scoringStatus === 'failed' ? 'status-cancel' : 'status-ing']">
                          {{ r.scoringStatus === 'scored' ? '已评' : r.scoringStatus === 'failed' ? '失败' : '待评' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-actions">
              <button class="btn-cancel" @click="detailVisible = false">关闭</button>
            </div>
          </div>
        </div>

        <div class="pagination" v-if="recordData.pages > 1">
          <button :disabled="recordData.page <= 1" @click="loadRecords(recordData.page - 1)">上一页</button>
          <span>{{ recordData.page }} / {{ recordData.pages }}</span>
          <button :disabled="recordData.page >= recordData.pages" @click="loadRecords(recordData.page + 1)">下一页</button>
        </div>
      </div>

      <!-- 开发者选项模块 -->
      <div v-if="tab === 'config'" class="admin-panel">
        <div class="panel-header">
          <h2 class="panel-title">开发者选项</h2>
          <button class="btn-add" @click="showAddDialog = true">+ 新增配置</button>
        </div>
        <table class="admin-table" v-if="configs.length">
          <thead>
            <tr>
              <th>配置键</th>
              <th>配置值</th>
              <th>数据类型</th>
              <th>描述</th>
              <th style="width:140px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in configs" :key="c.id">
              <td><code>{{ c.configKey }}</code></td>
              <td>
                <div class="config-value-cell">
                  <template v-if="c.valueType === 'boolean'">
                    <label class="switch">
                      <input type="checkbox" :checked="c.configValue === 'true'" @change="toggleBoolean(c)" />
                      <span class="slider"></span>
                    </label>
                    <span class="bool-label">{{ c.configValue === 'true' ? 'true' : 'false' }}</span>
                  </template>
                  <template v-else-if="c.valueType === 'json'">
                    <pre class="json-preview">{{ formatJsonPreview(c.configValue) }}</pre>
                  </template>
                  <template v-else>
                    <span class="string-preview" :title="c.configValue">{{ truncateText(c.configValue, 80) }}</span>
                  </template>
                </div>
              </td>
              <td><span :class="['type-tag', 'type-' + c.valueType]">{{ c.valueType }}</span></td>
              <td>{{ c.description || '--' }}</td>
              <td>
                <button class="btn-link" @click="editConfig(c)">编辑</button>
                <button class="btn-link btn-danger" @click="deleteConfig(c)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="empty" v-else>暂无配置项，点击"新增配置"添加</p>

        <!-- 新增/编辑弹窗 -->
        <div class="modal-overlay" v-if="showAddDialog || showEditDialog" @click.self="closeDialog">
          <div class="modal">
            <h3>{{ showEditDialog ? '编辑配置' : '新增配置' }}</h3>
            <div class="modal-form">
              <div class="modal-group">
                <label>配置键 <span class="required">*</span></label>
                <input v-model="configForm.configKey" :disabled="showEditDialog" placeholder="例如: feature.enable_xxx" />
              </div>
              <div class="modal-group">
                <label>数据类型 <span class="required">*</span></label>
                <select v-model="configForm.valueType">
                  <option value="string">string</option>
                  <option value="number">number</option>
                  <option value="boolean">boolean</option>
                  <option value="json">json</option>
                </select>
              </div>
              <div class="modal-group">
                <label>配置值 <span class="required">*</span></label>
                <div v-if="configForm.valueType === 'boolean'" class="bool-select">
                  <label class="radio-opt"><input type="radio" v-model="configForm.configValue" value="true" /> true</label>
                  <label class="radio-opt"><input type="radio" v-model="configForm.configValue" value="false" /> false</label>
                </div>
                <div v-else-if="configForm.valueType === 'json'" class="json-editor-wrap">
                  <div class="json-toolbar">
                    <button type="button" class="btn-format" @click="formatJson">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"/></svg>
                      格式化
                    </button>
                    <button type="button" class="btn-compress" @click="compressJson">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"/></svg>
                      压缩
                    </button>
                  </div>
                  <textarea v-model="configForm.configValue" rows="12" class="json-textarea" placeholder='例如: {"key": "value"}'></textarea>
                </div>
                <input v-else-if="configForm.valueType === 'number'" v-model="configForm.configValue" type="number" placeholder="输入数字" />
                <textarea v-else v-model="configForm.configValue" rows="6" class="string-textarea" placeholder="输入配置值"></textarea>
              </div>
              <div class="modal-group">
                <label>描述</label>
                <input v-model="configForm.description" placeholder="配置用途说明（可选）" />
              </div>
              <p class="error" v-if="configError">{{ configError }}</p>
              <div class="modal-actions">
                <button class="btn-cancel" @click="closeDialog">取消</button>
                <button class="btn-confirm" @click="saveConfig">确定</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 人员列表模块 -->
      <div v-if="tab === 'users'" class="admin-panel">
        <h2 class="panel-title">人员列表</h2>
        <div class="search-bar">
          <div class="search-group">
            <label>账号</label>
            <input v-model="userSearch.username" placeholder="搜索账号" @keyup.enter="loadUsers(1)" />
          </div>
          <div class="search-group">
            <label>邮箱</label>
            <input v-model="userSearch.email" placeholder="搜索邮箱" @keyup.enter="loadUsers(1)" />
          </div>
          <div class="search-actions">
            <button class="btn-search" @click="loadUsers(1)">查询</button>
            <button class="btn-reset" @click="resetUserSearch">重置</button>
          </div>
        </div>
        <div class="table-info">
          <span>共 <strong>{{ userData.total || 0 }}</strong> 位用户</span>
        </div>
        <table class="admin-table" v-if="userData.records && userData.records.length">
          <thead>
            <tr>
              <th>ID</th>
              <th>账号</th>
              <th>邮箱</th>
              <th>姓名</th>
              <th>角色</th>
              <th>状态</th>
              <th>注册时间</th>
              <th style="width:220px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="u in userData.records" :key="u.id">
              <td>{{ u.id }}</td>
              <td>{{ u.username }}</td>
              <td>{{ u.email }}</td>
              <td>{{ [u.familyName, u.givenName].filter(Boolean).join(' ') || '--' }}</td>
              <td>
                <span :class="['role-tag', u.role === 1 ? 'role-admin' : 'role-user']">
                  {{ u.role === 1 ? '超级管理员' : '普通用户' }}
                </span>
              </td>
              <td>
                <span :class="['status-tag', u.status === 1 ? 'status-ok' : 'status-cancel']">
                  {{ u.status === 1 ? '正常' : '禁用' }}
                </span>
              </td>
              <td>{{ formatDate(u.createTime) }}</td>
              <td>
                <button class="btn-link" @click="resetUserPassword(u)">重置密码</button>
                <button class="btn-link" v-if="u.role !== 1" @click="setUserRole(u, 1)">设为管理员</button>
                <button class="btn-link btn-danger" v-else @click="setUserRole(u, 0)">取消管理员</button>
                <button class="btn-link" v-if="u.status === 1" @click="setUserStatus(u, 0)">禁用</button>
                <button class="btn-link" v-else @click="setUserStatus(u, 1)">启用</button>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="empty" v-else>暂无用户</p>
        <div class="pagination" v-if="userData.pages > 1">
          <button :disabled="userData.page <= 1" @click="loadUsers(userData.page - 1)">上一页</button>
          <span>{{ userData.page }} / {{ userData.pages }}</span>
          <button :disabled="userData.page >= userData.pages" @click="loadUsers(userData.page + 1)">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../utils/api'

var toastId = 0

export default {
  name: 'AdminPanel',
  data() {
    return {
      tab: 'users',
      adminUser: localStorage.getItem('admin_username') || 'Admin',
      // Toast 通知
      toasts: [],
      // 确认弹窗
      confirmVisible: false,
      confirmData: { title: '', message: '', type: 'info', resolve: null },
      // 评测记录
      search: { username: '', email: '', scoreMin: '', scoreMax: '', startTime: '', endTime: '' },
      recordData: { records: [], total: 0, page: 1, size: 20, pages: 0 },
      // 开发者选项
      configs: [],
      showAddDialog: false,
      showEditDialog: false,
      configForm: { id: null, configKey: '', configValue: '', valueType: 'string', description: '' },
      configError: '',
      // 题目详情弹窗
      detailVisible: false,
      detailSessionId: '',
      detailLoading: false,
      detailRounds: [],
      // 人员列表
      userSearch: { username: '', email: '' },
      userData: { records: [], total: 0, page: 1, size: 20, pages: 0 }
    }
  },
  computed: {
      detailPhases() {
        var rounds = this.detailRounds || []
        var phaseLabels = { 1: '听力理解', 2: '口语表达', 3: '阅读理解', 4: '书写表达' }
        var details = []
        for (var p = 1; p <= 4; p++) {
          var phaseRounds = rounds.filter(function(r) { return r.phase === p })
          if (phaseRounds.length > 0) {
            details.push({ phase: p, label: phaseLabels[p] || ('Phase ' + p), rounds: phaseRounds })
          }
        }
        return details
      }
  },
  created() {
    this.loadUsers(1)
  },
  methods: {
    // ========== Toast 通知系统 ==========
    showToast(message, type) {
      var id = ++toastId
      this.toasts.push({ id: id, message: message, type: type || 'success' })
      setTimeout(() => { this.removeToast(id) }, 3500)
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    },

    // ========== 确认弹窗系统 ==========
    showConfirm(title, message, type) {
      var self = this
      return new Promise(function (resolve) {
        self.confirmData = { title: title, message: message, type: type || 'info', resolve: resolve }
        self.confirmVisible = true
      })
    },
    doConfirm() {
      this.confirmVisible = false
      if (this.confirmData.resolve) this.confirmData.resolve(true)
    },
    cancelConfirm() {
      this.confirmVisible = false
      if (this.confirmData.resolve) this.confirmData.resolve(false)
    },

    // ========== 通用 ==========
    switchTab(t) {
      this.tab = t
      if (t === 'records') this.loadRecords(1)
      if (t === 'config') this.loadConfigs()
      if (t === 'users') this.loadUsers(1)
    },
    questionTypeLabel(qt) {
      var map = { listen_and_answer: '听力理解', oral_read: '朗读', oral_picture: '看图说话', oral_repeat: '跟读', reading: '阅读理解', writing: '书写表达' }
      return map[qt] || qt || '--'
    },
    formatDate(d) {
      if (!d) return '--'
      return d.replace('T', ' ').substring(0, 19)
    },
    handleApiError(e) {
      if (e.response && e.response.status === 401) {
        this.showToast('登录已过期，请重新登录', 'error')
        var self = this
        setTimeout(function () { self.$router.push('/manage') }, 1500)
      } else {
        this.showToast('网络异常，请稍后重试', 'error')
      }
    },

    // ========== 评测记录 ==========
    async loadRecords(page) {
      try {
        var params = { page: page, size: 20 }
        if (this.search.username) params.username = this.search.username
        if (this.search.email) params.email = this.search.email
        if (this.search.scoreMin) params.scoreMin = this.search.scoreMin
        if (this.search.scoreMax) params.scoreMax = this.search.scoreMax
        if (this.search.startTime) params.startTime = this.search.startTime.replace('T', ' ') + ':00'
        if (this.search.endTime) params.endTime = this.search.endTime.replace('T', ' ') + ':00'
        var res = await api.get('/api/admin/records', { params: params })
        if (res.code === 200) {
          this.recordData = res.data
        } else if (res.code === 403) {
          this.showToast(res.message || '无管理员权限', 'error')
          var self = this
          setTimeout(function () { self.$router.push('/manage') }, 1500)
        } else {
          this.showToast(res.message || '加载失败', 'error')
        }
      } catch (e) {
        this.handleApiError(e)
      }
    },
    async showDetail(sessionId) {
      this.detailVisible = true
      this.detailSessionId = sessionId
      this.detailLoading = true
      this.detailRounds = []
      try {
        var res = await api.get('/api/admin/records/' + sessionId + '/detail')
        if (res.code === 200 && res.data) {
          this.detailRounds = res.data.roundResults || []
        } else {
          this.showToast('加载题目详情失败', 'error')
        }
      } catch (e) {
        this.showToast('加载题目详情失败', 'error')
      }
      this.detailLoading = false
    },
    resetSearch() {
      this.search = { username: '', email: '', scoreMin: '', scoreMax: '', startTime: '', endTime: '' }
      this.loadRecords(1)
    },

    // ========== 开发者选项 ==========
    async loadConfigs() {
      try {
        var res = await api.get('/api/admin/configs')
        if (res.code === 200) this.configs = res.data
        else this.showToast(res.message || '加载失败', 'error')
      } catch (e) { this.handleApiError(e) }
    },
    editConfig(c) {
      var value = c.configValue
      // 编辑 JSON 时自动格式化展示
      if (c.valueType === 'json' && value) {
        try { value = JSON.stringify(JSON.parse(value), null, 2) } catch (e) { /* keep original */ }
      }
      this.configForm = { id: c.id, configKey: c.configKey, configValue: value, valueType: c.valueType, description: c.description || '' }
      this.configError = ''
      this.showEditDialog = true
    },
    async toggleBoolean(c) {
      var newVal = c.configValue === 'true' ? 'false' : 'true'
      try {
        await api.put('/api/admin/configs/' + c.id, { configValue: newVal, valueType: 'boolean', description: c.description })
        c.configValue = newVal
        this.showToast('已切换为 ' + newVal, 'success')
      } catch (e) { this.showToast('操作失败', 'error') }
    },
    async deleteConfig(c) {
      var ok = await this.showConfirm('删除配置', '确定删除配置项 "' + c.configKey + '" 吗？此操作不可恢复。', 'danger')
      if (!ok) return
      try {
        var res = await api.delete('/api/admin/configs/' + c.id)
        if (res.code === 200) {
          this.showToast('配置已删除', 'success')
          this.loadConfigs()
        } else {
          this.showToast(res.message || '删除失败', 'error')
        }
      } catch (e) { this.showToast('操作失败', 'error') }
    },
    async saveConfig() {
      this.configError = ''
      if (!this.configForm.configKey) { this.configError = '配置键不能为空'; return }
      if (this.configForm.configValue === '' && this.configForm.valueType !== 'boolean') { this.configError = '配置值不能为空'; return }
      if (this.configForm.valueType === 'json') {
        try { JSON.parse(this.configForm.configValue) } catch (e) { this.configError = 'JSON格式不正确'; return }
      }
      try {
        var res
        if (this.showEditDialog) {
          res = await api.put('/api/admin/configs/' + this.configForm.id, this.configForm)
        } else {
          res = await api.post('/api/admin/configs', this.configForm)
        }
        if (res.code === 200) {
          this.showToast(this.showEditDialog ? '配置已更新' : '配置已添加', 'success')
          this.closeDialog()
          this.loadConfigs()
        } else {
          this.configError = res.message
        }
      } catch (e) {
        this.configError = '操作失败'
      }
    },
    closeDialog() {
      this.showAddDialog = false
      this.showEditDialog = false
      this.configForm = { id: null, configKey: '', configValue: '', valueType: 'string', description: '' }
      this.configError = ''
    },
    formatJson() {
      try {
        var parsed = JSON.parse(this.configForm.configValue)
        this.configForm.configValue = JSON.stringify(parsed, null, 2)
      } catch (e) {
        this.configError = 'JSON格式不正确，无法格式化'
      }
    },
    compressJson() {
      try {
        var parsed = JSON.parse(this.configForm.configValue)
        this.configForm.configValue = JSON.stringify(parsed)
      } catch (e) {
        this.configError = 'JSON格式不正确，无法压缩'
      }
    },
    formatJsonPreview(value) {
      if (!value) return ''
      try {
        var parsed = JSON.parse(value)
        var formatted = JSON.stringify(parsed, null, 2)
        // 列表预览最多显示6行
        var lines = formatted.split('\n')
        if (lines.length > 6) {
          return lines.slice(0, 5).join('\n') + '\n  ...'
        }
        return formatted
      } catch (e) {
        return value
      }
    },
    truncateText(text, maxLen) {
      if (!text) return ''
      if (text.length <= maxLen) return text
      return text.substring(0, maxLen) + '...'
    },

    // ========== 人员列表 ==========
    async loadUsers(page) {
      try {
        var params = { page: page, size: 20 }
        if (this.userSearch.username) params.username = this.userSearch.username
        if (this.userSearch.email) params.email = this.userSearch.email
        var res = await api.get('/api/admin/users', { params: params })
        if (res.code === 200) {
          this.userData = res.data
        } else if (res.code === 403) {
          this.showToast(res.message || '无管理员权限', 'error')
          var self = this
          setTimeout(function () { self.$router.push('/manage') }, 1500)
        } else {
          this.showToast(res.message || '加载失败', 'error')
        }
      } catch (e) {
        this.handleApiError(e)
      }
    },
    resetUserSearch() {
      this.userSearch = { username: '', email: '' }
      this.loadUsers(1)
    },
    async resetUserPassword(u) {
      var ok = await this.showConfirm('重置密码', '确定将用户 "' + u.username + '" 的密码重置为 123456 吗？', 'danger')
      if (!ok) return
      try {
        var res = await api.put('/api/admin/users/' + u.id + '/reset-password')
        if (res.code === 200) {
          this.showToast('密码已重置为 123456', 'success')
        } else {
          this.showToast(res.message || '操作失败', 'error')
        }
      } catch (e) { this.showToast('操作失败', 'error') }
    },
    async setUserRole(u, role) {
      var title = role === 1 ? '设为管理员' : '取消管理员'
      var msg = role === 1
        ? '确定将 "' + u.username + '" 设为超级管理员吗？该用户将拥有系统全部管理权限。'
        : '确定取消 "' + u.username + '" 的管理员权限吗？'
      var ok = await this.showConfirm(title, msg, role === 1 ? 'info' : 'danger')
      if (!ok) return
      try {
        var res = await api.put('/api/admin/users/' + u.id + '/role', { role: role })
        if (res.code === 200) {
          u.role = role
          this.showToast(role === 1 ? '已设为超级管理员' : '已取消管理员权限', 'success')
        } else {
          this.showToast(res.message || '操作失败', 'error')
        }
      } catch (e) { this.showToast('操作失败', 'error') }
    },
    async setUserStatus(u, status) {
      var title = status === 1 ? '启用用户' : '禁用用户'
      var msg = status === 1
        ? '确定启用用户 "' + u.username + '" 吗？'
        : '确定禁用用户 "' + u.username + '" 吗？禁用后该用户将无法登录系统。'
      var ok = await this.showConfirm(title, msg, status === 1 ? 'info' : 'danger')
      if (!ok) return
      try {
        var res = await api.put('/api/admin/users/' + u.id + '/status', { status: status })
        if (res.code === 200) {
          u.status = status
          this.showToast(status === 1 ? '用户已启用' : '用户已禁用', 'success')
        } else {
          this.showToast(res.message || '操作失败', 'error')
        }
      } catch (e) { this.showToast('操作失败', 'error') }
    },

    logout() {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_username')
      this.$router.push('/manage')
    }
  }
}
</script>

<style scoped>
.admin-layout { display: flex; min-height: 100vh; background: #f0f2f5; }

/* ===== Sidebar ===== */
.admin-sidebar {
  width: 240px; background: #1a1a2e; color: #fff;
  display: flex; flex-direction: column; flex-shrink: 0;
  position: fixed; top: 0; left: 0; bottom: 0; z-index: 100;
}
.admin-sidebar-logo {
  display: flex; align-items: center; gap: 10px;
  padding: 24px 20px; border-bottom: 1px solid rgba(255,255,255,0.08);
}
.admin-sidebar-logo img { height: 28px; object-fit: contain; filter: brightness(10); }
.admin-sidebar-logo span { font-size: 16px; font-weight: 700; letter-spacing: 1px; }
.admin-nav { flex: 1; padding: 12px 0; }
.admin-nav a {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 24px; color: rgba(255,255,255,0.6); text-decoration: none;
  font-size: 14px; transition: all 0.2s; border-left: 3px solid transparent;
}
.admin-nav a:hover { color: #fff; background: rgba(255,255,255,0.05); }
.admin-nav a.active { color: #fff; background: rgba(43,125,233,0.2); border-left-color: #2b7de9; }
.admin-sidebar-bottom { padding: 16px 20px; border-top: 1px solid rgba(255,255,255,0.08); }
.admin-user-info { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.admin-avatar {
  width: 32px; height: 32px; border-radius: 50%; background: #2b7de9;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; font-weight: 700; color: #fff;
}
.admin-username { font-size: 13px; color: rgba(255,255,255,0.8); }
.admin-logout {
  display: flex; align-items: center; gap: 8px;
  color: rgba(255,255,255,0.4); font-size: 13px; text-decoration: none; cursor: pointer;
}
.admin-logout:hover { color: #ef4444; }

/* ===== Main ===== */
.admin-main { flex: 1; margin-left: 240px; padding: 28px 32px; position: relative; }
.admin-panel { background: #fff; border-radius: 12px; padding: 28px; box-shadow: 0 2px 12px rgba(0,0,0,0.04); }
.panel-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.panel-title { font-size: 20px; font-weight: 700; color: #1a1a2e; margin: 0 0 20px; }
.panel-header .panel-title { margin: 0; }

/* ===== Toast 通知 ===== */
.toast-container {
  position: fixed; top: 24px; right: 32px; z-index: 9999;
  display: flex; flex-direction: column; gap: 10px; pointer-events: none;
}
.toast {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px; border-radius: 10px;
  font-size: 14px; font-weight: 500;
  box-shadow: 0 6px 24px rgba(0,0,0,0.12);
  pointer-events: auto; min-width: 280px; max-width: 420px;
  backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
}
.toast-success { background: #ecfdf5; color: #065f46; border: 1px solid #a7f3d0; }
.toast-error { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }
.toast-warning { background: #fffbeb; color: #92400e; border: 1px solid #fde68a; }
.toast-icon { flex-shrink: 0; }
.toast-success .toast-icon { color: #10b981; }
.toast-error .toast-icon { color: #ef4444; }
.toast-warning .toast-icon { color: #f59e0b; }
.toast-msg { flex: 1; line-height: 1.4; }
.toast-close {
  background: none; border: none; font-size: 18px; cursor: pointer;
  color: inherit; opacity: 0.4; padding: 0 0 0 8px; line-height: 1;
}
.toast-close:hover { opacity: 0.8; }
.toast-slide-enter-active { transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); }
.toast-slide-leave-active { transition: all 0.25s ease-in; }
.toast-slide-enter { transform: translateX(120%); opacity: 0; }
.toast-slide-leave-to { transform: translateX(120%); opacity: 0; }

/* ===== Confirm 确认弹窗 ===== */
.confirm-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; z-index: 2000;
}
.confirm-box {
  background: #fff; border-radius: 16px; padding: 36px 32px 28px;
  width: 400px; text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
  animation: confirmPop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes confirmPop { from { transform: scale(0.85); opacity: 0; } to { transform: scale(1); opacity: 1; } }
.confirm-icon { margin-bottom: 16px; }
.confirm-icon-info { color: #2b7de9; }
.confirm-icon-danger { color: #ef4444; }
.confirm-title { font-size: 18px; font-weight: 700; color: #1a1a2e; margin: 0 0 8px; }
.confirm-msg { font-size: 14px; color: #666; margin: 0 0 28px; line-height: 1.6; }
.confirm-actions { display: flex; justify-content: center; gap: 12px; }
.confirm-actions .btn-cancel {
  padding: 10px 28px; border: 1px solid #e0e3e8; border-radius: 8px;
  background: #fff; font-size: 14px; cursor: pointer; color: #666;
}
.confirm-actions .btn-cancel:hover { background: #f5f5f5; }
.confirm-actions .btn-confirm {
  padding: 10px 28px; background: #2b7de9; color: #fff;
  border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer;
}
.confirm-actions .btn-confirm:hover { background: #1a6ad4; }
.confirm-actions .btn-confirm-danger { background: #ef4444; }
.confirm-actions .btn-confirm-danger:hover { background: #dc2626; }
.modal-fade-enter-active { transition: opacity 0.2s; }
.modal-fade-leave-active { transition: opacity 0.15s; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }

/* ===== Search Bar ===== */
.search-bar {
  display: flex; flex-wrap: wrap; gap: 16px; align-items: flex-end;
  padding: 20px; background: #f8f9fc; border-radius: 10px; margin-bottom: 20px;
}
.search-group { display: flex; flex-direction: column; gap: 4px; }
.search-group label { font-size: 12px; color: #888; font-weight: 600; }
.search-group input, .search-group select {
  padding: 8px 12px; border: 1px solid #e0e3e8; border-radius: 6px;
  font-size: 13px; outline: none; background: #fff; min-width: 150px;
}
.search-group input:focus { border-color: #2b7de9; }
.score-range { display: flex; align-items: center; gap: 6px; }
.score-range input { min-width: 70px; width: 80px; }
.score-range span { color: #999; }
.search-actions { display: flex; gap: 8px; align-items: flex-end; }
.btn-search {
  padding: 8px 20px; background: #2b7de9; color: #fff;
  border: none; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.btn-search:hover { background: #1a6ad4; }
.btn-reset {
  padding: 8px 16px; background: #fff; color: #666;
  border: 1px solid #ddd; border-radius: 6px; font-size: 13px; cursor: pointer;
}
.btn-reset:hover { background: #f5f5f5; }

/* ===== Table ===== */
.table-info { font-size: 13px; color: #888; margin-bottom: 12px; }
.table-info strong { color: #2b7de9; }
.admin-table { width: 100%; border-collapse: collapse; }
.admin-table th {
  background: #f7f8fc; padding: 12px 14px; font-size: 13px;
  color: #555; font-weight: 600; text-align: left; white-space: nowrap;
}
.admin-table td { padding: 12px 14px; font-size: 13px; color: #333; border-top: 1px solid #f0f0f0; }
.admin-table tbody tr:hover { background: #fafbfd; }
.score-badge { font-weight: 700; color: #2b7de9; }
.status-tag { padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.status-ok { background: #ecfdf5; color: #10b981; }
.status-ing { background: #fffbeb; color: #f59e0b; }
.status-cancel { background: #fef2f2; color: #ef4444; }
.empty { color: #999; font-size: 14px; text-align: center; padding: 60px; }

/* ===== Pagination ===== */
.pagination { display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 20px; }
.pagination button {
  padding: 6px 16px; border: 1px solid #ddd; border-radius: 6px;
  background: #fff; font-size: 13px; cursor: pointer;
}
.pagination button:hover:not(:disabled) { border-color: #2b7de9; color: #2b7de9; }
.pagination button:disabled { opacity: 0.4; cursor: not-allowed; }
.pagination span { font-size: 13px; color: #666; }

/* ===== Config ===== */
.btn-add {
  padding: 8px 20px; background: #2b7de9; color: #fff;
  border: none; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.btn-add:hover { background: #1a6ad4; }
code { background: #f1f3f5; padding: 2px 8px; border-radius: 4px; font-size: 13px; color: #e44; }
.config-value-cell { display: flex; align-items: center; gap: 8px; }
.json-preview {
  background: #f8f9fc; padding: 8px 12px; border-radius: 6px;
  font-size: 12px; max-width: 320px; max-height: 120px; overflow: auto;
  white-space: pre; word-break: break-all; margin: 0;
  line-height: 1.5; color: #555;
}
.type-tag { padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.type-string { background: #eff6ff; color: #3b82f6; }
.type-number { background: #f0fdf4; color: #22c55e; }
.type-boolean { background: #fef3c7; color: #d97706; }
.type-json { background: #fae8ff; color: #a855f7; }
.btn-link { background: none; border: none; color: #2b7de9; font-size: 13px; cursor: pointer; padding: 4px 8px; }
.btn-link:hover { text-decoration: underline; }
.btn-danger { color: #ef4444; }
.btn-danger:hover { color: #dc2626; }

/* ===== User Roles ===== */
.role-tag { padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.role-admin { background: #fef3c7; color: #d97706; }
.role-user { background: #f1f3f5; color: #666; }

/* Toggle Switch */
.switch { position: relative; display: inline-block; width: 40px; height: 22px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
  background: #ccc; transition: 0.3s; border-radius: 22px;
}
.slider:before {
  content: ""; position: absolute; height: 16px; width: 16px;
  left: 3px; bottom: 3px; background: #fff; transition: 0.3s; border-radius: 50%;
}
input:checked + .slider { background: #2b7de9; }
input:checked + .slider:before { transform: translateX(18px); }
.bool-label { font-size: 13px; color: #666; }

/* ===== Modal ===== */
.modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; z-index: 1000;
}
.modal {
  background: #fff; border-radius: 16px; padding: 32px;
  width: 640px; max-width: 90vw; max-height: 90vh; overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15);
}
.modal h3 { font-size: 18px; font-weight: 700; color: #1a1a2e; margin: 0 0 24px; }
.modal-group { margin-bottom: 18px; }
.modal-group label { display: block; font-size: 13px; color: #555; margin-bottom: 6px; font-weight: 600; }
.required { color: #ef4444; }
.modal-group input, .modal-group select, .modal-group textarea {
  width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 6px;
  font-size: 14px; outline: none; box-sizing: border-box; font-family: inherit;
}
.modal-group input:focus, .modal-group select:focus, .modal-group textarea:focus { border-color: #2b7de9; }
.modal-group input:disabled { background: #f5f5f5; color: #999; }
.modal-group textarea { resize: vertical; font-family: 'SF Mono', 'Consolas', monospace; font-size: 13px; }
/* String textarea */
.string-textarea { min-height: 120px; line-height: 1.6; }
/* JSON editor */
.json-editor-wrap { display: flex; flex-direction: column; gap: 0; }
.json-toolbar {
  display: flex; gap: 8px; padding: 8px 10px;
  background: #f7f8fc; border: 1px solid #ddd; border-bottom: none;
  border-radius: 6px 6px 0 0;
}
.btn-format, .btn-compress {
  display: flex; align-items: center; gap: 4px;
  padding: 4px 12px; border: 1px solid #ddd; border-radius: 4px;
  background: #fff; font-size: 12px; color: #555; cursor: pointer;
  transition: all 0.15s;
}
.btn-format:hover { border-color: #2b7de9; color: #2b7de9; background: #eff6ff; }
.btn-compress:hover { border-color: #8b5cf6; color: #8b5cf6; background: #faf5ff; }
.json-textarea {
  min-height: 200px; line-height: 1.5;
  border-radius: 0 0 6px 6px !important;
  tab-size: 2;
}
/* List preview styles */
.string-preview {
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
  overflow: hidden; word-break: break-all; line-height: 1.5;
  max-width: 320px; cursor: default;
}
.bool-select { display: flex; gap: 24px; padding: 8px 0; }
.radio-opt { font-size: 14px; color: #333; display: flex; align-items: center; gap: 6px; cursor: pointer; }
.radio-opt input { accent-color: #2b7de9; }
.error { color: #ef4444; font-size: 13px; margin-bottom: 12px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 8px; }
.btn-cancel { padding: 10px 24px; border: 1px solid #ddd; border-radius: 6px; background: #fff; font-size: 14px; cursor: pointer; }
.btn-cancel:hover { background: #f5f5f5; }
.btn-confirm { padding: 10px 24px; background: #2b7de9; color: #fff; border: none; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; }
.btn-confirm:hover { background: #1a6ad4; }

/* ===== Detail Modal ===== */
.detail-modal { width: 960px; max-width: 95vw; }
.detail-loading { text-align: center; padding: 40px; color: #999; font-size: 14px; }
.detail-phase { margin-bottom: 20px; }
.detail-phase-title { font-size: 14px; font-weight: 600; color: #333; margin-bottom: 8px; padding-bottom: 6px; border-bottom: 2px solid #2b7de9; }
.detail-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.detail-table th { background: #f5f7fa; color: #666; font-weight: 600; padding: 6px 8px; text-align: center; border-bottom: 1px solid #e0e0e0; white-space: nowrap; }
.detail-table td { padding: 6px 8px; border-bottom: 1px solid #f0f0f0; vertical-align: top; }
.td-detail-q { max-width: 220px; }
.td-detail-a { max-width: 180px; }
.td-detail-score { font-weight: 700; color: #2b7de9; text-align: center; }
.dq-scenario { color: #555; margin-bottom: 2px; font-size: 11px; }
.dq-question { color: #2b7de9; font-weight: 500; }
.row-failed td { color: #ccc; }
.row-failed .td-detail-score { color: #e74c3c; }
.type-tag-sm { padding: 1px 6px; border-radius: 4px; font-size: 10px; font-weight: 600; background: #eff6ff; color: #3b82f6; white-space: nowrap; }
.timeout-text { color: #e74c3c; font-style: italic; }
.audio-text { color: #888; font-style: italic; }
.no-answer { color: #ccc; }

@media (max-width: 768px) {
  .admin-sidebar { width: 200px; }
  .admin-main { margin-left: 200px; padding: 16px; }
  .search-bar { flex-direction: column; }
  .toast-container { right: 16px; left: 16px; }
  .toast { min-width: auto; }
}
</style>
